function D4Icon() {
  return (
    <svg
      width="24"
      height="24"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentcolor"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12.485 2.24a1 1 0 01.39.389l9.922 17.886A1 1 0 0121.923 22H2.077a1 1 0 01-.875-1.485l9.923-17.886a1 1 0 011.36-.39zM12 5.173L3.775 20h16.449L12 5.174zM13.995 10v5.076H15v1.78h-1.005V18.4h-1.94v-1.544H8V14.97L12.055 10h1.94zm-1.94 2.479l-2.142 2.597h2.142V12.48z" />
    </svg>
  );
}

export default D4Icon;
